import { DisctionaryContent } from "src/app/services/sitecoreDictionary/dictionary-content.service";
import { Component, TemplateRef, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, Validators, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { ApiResponse, CamDeleteModel } from 'src/app/models/interface/CAM/baseResponseInterfaces';
import { Branch } from 'src/app/models/interface/CAM/CompanyProfileInterface';
import { Department, DepartmentByID, DepartmentRequest } from 'src/app/models/interface/CAM/TravellerInterface';
import { CamService } from 'src/app/services/camService/cam.service';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { CompanyManagementContentService } from '../../services/company-management-content.service';
import { NgIf, NgFor } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatSuffix, MatError } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { CamEmptyStateComponent } from '../cam-empty-state/cam-empty-state.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { BookingContentService } from "src/app/services/bookingContentService/booking-content.service";

@Component({
    selector: 'app-department',
    templateUrl: './department.component.html',
    styleUrls: ['./department.component.scss'],
    imports: [ReactiveFormsModule, NgIf, MatIcon, MatFormField, MatLabel, MatSuffix, MatSelect, NgFor, MatOption, MatError, MatInput, MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, CamEmptyStateComponent, CdkScrollable, MatDialogContent, MatDialogActions]
})
export class DepartmentComponent implements OnInit, OnDestroy {
  dictionaryContentData: any = null;
    manageCompanyContent: any;
  displayedColumns: string[] = ['Department', 'Department Email', 'Department Phone', 'Branch', 'Department Head Name', 'Action']
  departmentForm: FormGroup;
  Addnew: boolean = false;
  subAgentId: any;
  isLoading = true;
  GetAllHeadDepartmentList: any

  commonObjPipes: any = {
    GetAllBranch: { pipe: [] as Branch[], all: [] as Branch[] },
    GetAllDetails: { pipe: [] as Department[], all: [] as Department[] },
    GetAllHeadDepartment: { pipe: [], all: [] },
  }

  @ViewChild('selectionWarning') selectionWarning!: TemplateRef<any>;
  currentItem: any;
  content: any;
  dictionaryContent:any;
  private readonly destroy$ = new Subject<void>();
  constructor(
    private readonly bookingContentService: BookingContentService, private readonly _camService: CamService,
    private readonly fb: FormBuilder,
    private readonly dialog: MatDialog,
    private readonly _ToastrApiService: ToastrApiService,
    public _CommonService: CommonService,
    private readonly crypto: CryptoService,
    private readonly _CompanyManagementService: CompanyManagementService,
    private readonly contentService: CompanyManagementContentService,
    private readonly dictionaryContentService:DisctionaryContent
  , private _dictionaryContentService: DisctionaryContent) {
    this.departmentForm = this.fb.group({
      selectBranch: [null, [Validators.required]],
      nemeOfTheDepartment: [null, [Validators.required, Validators.maxLength(100), Validators.minLength(3)]],
      departmentEmail: [null, [
        
        Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/),
        Validators.minLength(5),
        Validators.maxLength(255)
      ]],
      departmentphoneNo: [null, [ Validators.minLength(8), Validators.maxLength(12)]],
      departmentFax: [null, [Validators.pattern(/^\d{7,12}$/), Validators.minLength(7), Validators.maxLength(15)]],
      travellerBudget: [null, [Validators.maxLength(10)]],
      numberOfStaff: [null, [Validators.maxLength(7)]],
      numberOfTravellers: [null, [Validators.maxLength(7)]],
      selectHeadOfDepartment: [null],
      departmentId: [null],
      flag: ['ADD']
    })
  }

  ngOnInit(): void {
    this._dictionaryContentService.content$.subscribe((res: any) => { if (res) { this.dictionaryContentData = res; } });
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.content = res;
    });
    this.dictionaryContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.dictionaryContent = res;
    });
    this.subAgentId = this.crypto.getValueFromKey('USERID');
    this.loadInitialData()
    this.getDepartmentList()
      this.contentService.content$.subscribe((res: any) => { this.manageCompanyContent = res; });
  }

  handleEvent(event: string) {
    if (event.includes('department')) {
      this.Addnew = true;
    }
  }


  async loadInitialData() {
    try {
      this.isLoading = true;

      const [headDepartments, branches] = await Promise.all([

        this._camService.getDepartmentHeadDetails(),
        this._camService.GetBranchInformation()
      ]);
      this.bindLists('GetAllHeadDepartment', headDepartments.data);
      this.bindLists('GetAllBranch', branches.data);

      // console.log(branches)

    } catch (error) {
      console.error(error);
      this._ToastrApiService.show('error', 'Failed to load department data.');
    } finally {
      this.isLoading = false;
    }
  }


  getDepartmentList() {
    this._camService.getDepartmentDetails().then((res: ApiResponse<Department[]>) => {
      if(res.status === "Success"){
        this.bindLists('GetAllDetails', res.data);
      }else{
        this.bindLists('GetAllDetails', []);
      }

    }).catch((error) => {
     this.bindLists('GetAllDetails', []);
      const message =
          error?.error?.message ||
          error?.message ||
          'Something went wrong. Please try again.';
     this._CompanyManagementService.view_error_message(message,error?.code);
      console.error(error)
    }).finally(() => {
      this.isLoading = false
    })
  }


  bindLists(key: string, lists: any[]) {
    this.commonObjPipes[key].pipe = lists;
    this.commonObjPipes[key].all = lists;
  }

  addNewDepartment() {
    this.Addnew = true
    this.departmentForm.reset({
      departmentId: null,
      flag: "ADD"
    })

    this._CompanyManagementService.company_management_department('Add link','Add', this.commonObjPipes.GetAllDetails.pipe.length)//GTM use
  }

  onCancel() {
    this.Addnew = false
    this.departmentForm.markAsPristine();
    this._CompanyManagementService.company_management_department('Cancel button','Cancel', this.commonObjPipes.GetAllDetails.pipe.length)//GTM use

  }

  onSave() {
    this._CompanyManagementService.company_management_department('Save button','Save', this.commonObjPipes.GetAllDetails.pipe.length)//GTM use


    if (this.departmentForm.invalid) {
      return
    }

    const deparmentPayload: DepartmentRequest = {

      departmentEmail: this.departmentForm.value.departmentEmail,
      departmentFax: this.departmentForm.value.departmentFax,
      departmentId: this.departmentForm.value.departmentId,
      departmentphoneNo: this.departmentForm.value.departmentphoneNo,
      flag: this.departmentForm.value.flag,
      nameOfTheDepartment: this.departmentForm.value.nemeOfTheDepartment,
      numberOfStaff: this.departmentForm.value.numberOfStaff,
      numberOfTravellers: this.departmentForm.value.numberOfTravellers,
      selectBranch: this.departmentForm.value.selectBranch,
      selectHeadOfDepartment: this.departmentForm.value.selectHeadOfDepartment,
      travellerBudget: this.departmentForm.value.travellerBudget
    }


    this._camService.insertUpdateDepartmentDetailsV1(this.subAgentId, this.fformatSpecificFields(deparmentPayload)).then((res) => {

      if (!res) {
        this._ToastrApiService.show('error', 'No response received from server.');
        return;
      }

      // Handle API response
      switch (res.status) {
        case 'Created':
          this._ToastrApiService.show('success', res.message || 'Department created successfully.');
          this._CompanyManagementService.save_success('Department', 'Success')//GTM use
          break;

        case 'Success':
          this._ToastrApiService.show('success', res.message || this.dictionaryContent?.['b2b.updatedepartmentdetails.200success'] || this.dictionaryContentData?.phrases?.b2b?.updatedepartmentdetails?.['200success'] || 'Department updated successfully.');
          this._CompanyManagementService.save_success('Department', 'Success')//GTM use
          break;

        case 'Conflict':
          this._ToastrApiService.show('warning', res.message || 'Duplicate entry detected.');
          break;

        default:
          this._ToastrApiService.show('error', res.message || 'Unexpected response from server.');
          console.warn('Unhandled status:', res);
          break;
      }


      //Refresh the page
      this.getDepartmentList()
      this._CommonService.formResetTrigger();
      this.Addnew = false;
      this.departmentForm.reset({
        departmentId: null,
        flag: "ADD"
      })


    }).catch((error) => {
      const errorMessage =
        error?.error?.message ||
        error?.message ||
        'Something went wrong while saving the department. Please try again later.';
      this._CompanyManagementService.view_error_message(errorMessage,error?.code);
      this._ToastrApiService.show('error', errorMessage);
    })
  }


  fformatSpecificFields(data: any): any {
    const keysToFormat = ['travellerBudget', 'numberOfStaff', 'numberOfTravellers'];
    const formatted = { ...data };
    keysToFormat.forEach(key => {
      const value = data[key];
      formatted[key] = (value === 0 || value === '' || value === null || value === undefined)
        ? null
        : String(value);
    });
    return formatted;
  }

  onEdit(item: Department) {

    this._CompanyManagementService.company_management_department('Edit button','Edit', this.commonObjPipes.GetAllDetails.pipe.length)//GTM use

    this.Addnew = true;
    this._camService.getDepartmentDetailsById(item.departmentId).then((res: ApiResponse<DepartmentByID[]>) => {
      if (res.status == "Success") {
        const dept: DepartmentByID = res.data[0];
        this.GetAllHeadDepartmentList = this.commonObjPipes.GetAllHeadDepartment.all;;
        const targetUserId = dept.departmentHeadUserId;
        const matchedRecord = this.GetAllHeadDepartmentList.find((item: any) => item?.userId == targetUserId);


        this.departmentForm.patchValue({
          departmentEmail: dept.departmentEmail,
          departmentFax: dept.faxNumber,
          departmentId: dept.departmentId,
          departmentphoneNo: dept.departmentPhone,
          flag: 'UPDATE',
          nemeOfTheDepartment: dept.departmentName,
          numberOfStaff: dept.numberOfStaff === 0 ? null : dept.numberOfStaff,
          numberOfTravellers: dept.numberOfTravellers === 0 ? null : dept.numberOfTravellers,
          selectBranch: dept.clientBranchId, // FIXED
          selectHeadOfDepartment: matchedRecord?.userId,
          travellerBudget: dept.travelBudget === 0 ? null : dept.travelBudget,

        });
        // Mark the form as pristine after patching values
      }
    }).catch((error) => {
      console.error(error)
      const errMsg = error?.message || error?.error?.message || 'Something went wrong while fetching Department details by ID.';
      this._CompanyManagementService.view_error_message(errMsg,error?.code);
      this._ToastrApiService.show('error', errMsg)
    });
  }

  onRemove(item: Department) {
    this._CompanyManagementService.company_management_department('Remove button','Remove', this.commonObjPipes.GetAllDetails.pipe.length)//GTM use

    this.currentItem = item;
    this.dialog.open(this.selectionWarning, {
      data: item,
    });
  }

  confirmDelete(item: Department) {

    const request: CamDeleteModel = {
      id: item.departmentId,
      type: 'DEPARTMENT'
    }

    this._camService.DeleteCAMitemBytype(request).then((res) => {
      if (res.status == "Success") {
        this._ToastrApiService.show('success', res.message);
        this.currentItem = undefined;
        this.getDepartmentList()
        this._CompanyManagementService.department_remove_Successfully('Confirm','Success')//GTM use
      }
    }).catch((error) => {
      const errorMessage =
        error?.error?.message ||
        error?.message ||
        'Something went wrong while delete the department. Please try again later.';
        this._CompanyManagementService.view_error_message(errorMessage,error?.code);
      this._ToastrApiService.show('error', errorMessage);
    });
  }

  allowedNumberOnly(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }


  CloseDialog(result: boolean) {
    if (result) {
      this.confirmDelete(this.currentItem);
      this._CompanyManagementService.department_remove('Proceed','Are you sure you want to remove this Department?')//GTM use
    }
    if(!result){
      this._CompanyManagementService.department_remove('Cancel','Are you sure you want to remove this Department?')//GTM use
    }

    this.dialog.closeAll(); // Closes the dialog
  }

  getValueOrEmpty(value: any): any {
    if (
      value === null ||
      value === undefined ||
      (typeof value === 'string' && value.trim() === '') ||
      (Array.isArray(value) && value.length === 0) ||
      (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0)
    ) {
      return '';
    }
    return value;
  }

  sitecoreGetWarningMessage(messageId: string): any {
    return this.content?.warningList?.find(
      (item: any) => item.messageID === messageId
    );
  }
  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
